import { Directive, Input, inject } from '@angular/core'
import { ElderSelectComponent, Sort } from '@elderbyte/ngx-starter'
import { FacilitySchedule } from './facility-schedule'
import { FacilityScheduleFilter, FacilityScheduleService } from './facility-schedule.service'

@Directive({
  selector: '[appFacilityWorkScheduleSelect]',
})
export class FacilityScheduleSelectDirective {
  /***************************************************************************
   *                                                                         *
   * Fields                                                                  *
   *                                                                         *
   **************************************************************************/
  private select = inject<ElderSelectComponent<FacilitySchedule>>(ElderSelectComponent)
  private facilityWorkScheduleService = inject(FacilityScheduleService)

  /***************************************************************************
   *                                                                         *
   * Constructor                                                             *
   *                                                                         *
   **************************************************************************/

  constructor() {
    this.select.displayProperty = 'name'
    this.select.placeholder = 'schedules.facility'
    this.select.dataSource = this.facilityWorkScheduleService
    this.select.sorts = [new Sort('validityInterval', 'asc')]
  }

  @Input()
  public set facilityId(facilityId: string) {
    if (facilityId) {
      this.select.filters = [FacilityScheduleFilter.facilityId(facilityId)]
    }
  }

  /***************************************************************************
   *                                                                         *
   * Public API                                                              *
   *                                                                         *
   **************************************************************************/

  public clear(): void {
    this.select.clear(null)
  }
}
